import { useFieldMappings } from '../hooks'

export function FieldMappingsTable({ sourceCode }: { sourceCode: string }) {
  const q = useFieldMappings(sourceCode)

  if (q.isLoading) return <p className="text-sm text-slate-500">Wczytywanie mapowań...</p>
  if (q.isError) return <p className="text-sm text-red-600">Błąd: {String(q.error)}</p>
  if (!q.data || q.data.length === 0) {
    return (
      <p className="text-sm text-slate-500 italic">
        Brak zmapowanych pól. Mapowanie ustawiasz per pole w Form Builderze
        (<code className="font-mono">/settings/forms</code> - edycja pola - sekcja "Mapowania zewnętrzne").
      </p>
    )
  }

  // Grupuj po objectType (contract/customer/annex)
  const byObjectType = q.data.reduce<Record<string, typeof q.data>>((acc, row) => {
    ;(acc[row.objectType] ??= []).push(row)
    return acc
  }, {})

  return (
    <div className="space-y-6">
      {Object.entries(byObjectType).map(([objectType, items]) => (
        <section key={objectType}>
          <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-700 mb-2">
            {objectTypeLabel(objectType)}{' '}
            <span className="text-xs text-slate-400">({items.length})</span>
          </h3>
          <table className="w-full text-sm">
            <thead className="text-left text-[11px] uppercase tracking-wide text-slate-500 border-b">
              <tr>
                <th className="py-2 pr-4">Pole</th>
                <th className="py-2 pr-4">Kod</th>
                <th className="py-2 pr-4">Typ</th>
                <th className="py-2 pr-4">Ścieżka w payload</th>
                <th className="py-2 pr-4">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map(row => (
                <tr key={row.fieldDefinitionId}>
                  <td className="py-2 pr-4 text-slate-900 font-medium">{row.labelPl}</td>
                  <td className="py-2 pr-4 text-slate-600 font-mono text-xs">{row.fieldCode}</td>
                  <td className="py-2 pr-4 text-slate-500 text-xs">{row.fieldType}</td>
                  <td className="py-2 pr-4">
                    <code className="rounded bg-slate-100 px-2 py-0.5 text-xs font-mono">{row.path}</code>
                  </td>
                  <td className="py-2 pr-4">
                    {row.isActive ? (
                      <span className="rounded bg-emerald-50 text-emerald-700 px-1.5 py-0.5 text-[10px]">
                        aktywne
                      </span>
                    ) : (
                      <span className="rounded bg-slate-100 text-slate-500 px-1.5 py-0.5 text-[10px]">
                        nieaktywne
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      ))}
    </div>
  )
}

function objectTypeLabel(t: string): string {
  if (t === 'contract') return 'Umowa'
  if (t === 'customer') return 'Klient'
  if (t === 'annex') return 'Aneks'
  return t
}
